import React, { Fragment, useEffect, useState } from 'react'
import Validator from 'components/validator'
import Dropdown from 'components/dropdown'
import Select from 'components/form/select-input'
import { DI } from 'modules'
import './styles.css'

class TVUFields extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEnableReciever: false,
      username: this.getUsername(),
      options: [],
    }
  }

  componentDidMount() {
    if (this.state.username.length) {
      this.getReceivers()
    }
  }

  getUsername = () => {
    const user = this.props.user.currentUser.payload
    const username = user && user.tvu_email ? user.tvu_email : ''
    return username
  }

  getReceivers = () => {
    this.props.actions.targets
      .getTVUReceivers(this.state.username)
      .then(resp => {
        if (resp.body.length > 0) {
          this.setState({
            isEnableReciever: true,
            options: resp.body,
          })
        }
      })
  }

  handleChange = event => {
    this.setState({
      username: event.target.value,
    })
  }

  render() {
    const {
      props: { strings, form, onValidateForm },
      state: { isEnableReciever, options, username },
    } = this

    return (
      <Fragment>
        <Field
          label={strings['page.lives.view.add_stream.tvu_username']}
          input={
            <Validator
              value={form.confirm || 'empty'}
              onValidateForm={onValidateForm}
              validators={[{ name: 'username', params: form.username }]}
              render={({ hasError, messages, value }) => (
                <Fragment>
                  <input
                    type="text"
                    className={`input tvuinput ${hasError ? '_error' : ''}`}
                    name="username"
                    value={username || form.confirm}
                    placeholder="example@example.com"
                    onChange={this.handleChange}
                  />
                  <button
                    type="button"
                    className="button tvubutton"
                    onClick={username.length > 0 && this.getReceivers}
                  >
                    {strings['page.lives.view.add_stream.tvu_validate']}
                  </button>
                </Fragment>
              )}
            />
          }
        />

        {isEnableReciever && (
          <Field
            label={strings['page.lives.view.add_stream.tvu_receiver']}
            input={
              <Select
                items={options}
                getTitle={item => item.name}
                getValue={item => item.peerId}
                name="receiver"
                value={form.receiver}
                notSelected={true}
                isRequired
                isInput={true}
                disabled={options.length === 0}
              />
            }
            disabled={true}
          />
        )}
      </Fragment>
    )
  }
}

function Field(props) {
  return (
    <div className="field" disabled={true}>
      <div className="field-label">
        <label className="label">{props.label}</label>
      </div>
      <div className="field-input">{props.input}</div>
    </div>
  )
}

export default DI(['targets', 'user'])(TVUFields)
